import { Link } from 'react-router-dom';
import { House } from '@phosphor-icons/react';
import { useLanguage } from '../../context/LanguageContext';

/* ──────────────────────────────────────────
   Friendly 404 — replaces the old silent
   redirect home so mistyped and stale
   deep-links explain themselves.
   ────────────────────────────────────────── */
export default function NotFound() {
  const { t } = useLanguage();

  return (
    <div className="min-h-full flex flex-col items-center justify-center py-20 px-4 text-center">
      <div className="w-16 h-16 rounded-2xl bg-ft-accent-light text-ft-accent flex items-center justify-center text-2xl mb-4">
        <House />
      </div>
      <h1 className="text-xl font-bold text-ft-text-1 mb-1">{t('notFound.title')}</h1>
      <p className="text-sm text-ft-text-3 mb-6 max-w-md">{t('notFound.hint')}</p>
      <Link
        to="/people"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-ft-accent text-white font-bold text-sm no-underline hover:bg-ft-accent-hover transition-colors"
      >
        {t('notFound.backToPeople')}
      </Link>
    </div>
  );
}
